import { UseMutationOptions } from 'react-query/types/react/types'
import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { CardDismissal } from 'types'
import { CardDismissalService } from 'api/services/CardDismissalService'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export type Options = Omit<
  UseMutationOptions<{ card_dismissal: CardDismissal }, void, CardDismissal>,
  'mutationKey' | 'mutationFn'
>

export const useCreateCardDismissal = (options?: Options) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  return useMutation<{ card_dismissal: CardDismissal }, void, CardDismissal>(
    'createCardDismissal',
    async (identifier) => {
      const response = await CardDismissalService.createCardDismissal(identifier)

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }
      localStorage.setItem(`home_cta:${currentWorkspaceId}:${identifier}`, 'true')
      queryClient.invalidateQueries([currentWorkspaceId, 'cardDismissal', identifier])
      return response.data
    },
    {
      ...options,
    },
  )
}
